var render = function () {
  var _vm$value$contact, _vm$value$contact2, _vm$value$contact3, _vm$value$delivery, _vm$city, _vm$value$payment;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order-summary",
    class: [("order-summary_" + (_vm.color))]
  }, [_vm.activeProductList.length ? _c('div', {
    staticClass: "order-summary__block"
  }, [_c('div', {
    staticClass: "order-summary__title"
  }, [_vm._v("\n      " + _vm._s(_vm.productListTitle) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__product-wrapper"
  }, [_vm._l(_vm.activeProductList, function (product, index) {
    return [!_vm.hide || _vm.hide && index < 2 ? _c('div', {
      key: product.id,
      staticClass: "order-summary__product"
    }, [_c(_vm.productLink ? 'nuxt-link' : 'div', {
      tag: "nuxt-link",
      staticClass: "order-summary__photo-wrapper",
      attrs: {
        "to": product.path
      }
    }, [_c('img', {
      staticClass: "order-summary__photo",
      attrs: {
        "src": product.thumbnail.x1,
        "alt": product.name
      }
    })]), _vm._v(" "), _c(_vm.productLink ? 'nuxt-link' : 'div', {
      tag: "nuxt-link",
      staticClass: "order-summary__product-name link link_wu",
      attrs: {
        "to": product.path
      }
    }, [_c('div', {
      staticClass: "fz-12 lh-15"
    }, [_vm._v("\n              " + _vm._s(product.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "order-summary__product-subtext"
    }, [_c('ProductStatus', {
      staticClass: "mt-3",
      attrs: {
        "size": "small",
        "value": product.status.name,
        "code": product.status.code
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ml-3"
    }, [_vm._v("\n                " + _vm._s(product.quantity) + " шт.\n              ")])], 1)]), _vm._v(" "), product.price ? _c('TSPrice', {
      staticClass: "order-summary__product-price",
      attrs: {
        "price": product.price,
        "size": "small",
        "color": _vm.color,
        "reverse-order": ""
      }
    }) : _vm._e()], 1) : _vm._e()];
  }), _vm._v(" "), _vm.activeProductList.length > 2 ? _c('span', {
    staticClass: "link-icon link-icon_wu mt-10 lh-14",
    on: {
      "click": function ($event) {
        _vm.hide = !_vm.hide;
      }
    }
  }, [_c('div', {
    staticClass: "link-icon__text"
  }, [_vm._v(_vm._s(_vm.hide ? 'Показать все товары' : 'Скрыть товары'))]), _vm._v(" "), _c('div', {
    class: [_vm.hide ? 'link-icon__icon-bottom-arrow' : 'link-icon__icon-top-arrow']
  })]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-summary__block"
  }, [_c('div', {
    staticClass: "order-summary__title"
  }, [_vm._v("\n      Контактные данные\n    ")]), _vm._v(" "), (_vm$value$contact = _vm.value.contact) !== null && _vm$value$contact !== void 0 && _vm$value$contact.name ? _c('div', {
    staticClass: "order-summary__props-wrapper"
  }, [_c('div', {
    staticClass: "order-summary__prop"
  }, [_vm._v("\n        ФИО:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__value"
  }, [_vm._v("\n        " + _vm._s(_vm.value.contact.name) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-summary__props-wrapper"
  }, [_c('div', {
    staticClass: "order-summary__prop"
  }, [_vm._v("\n        Телефон:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__value"
  }, [_vm._v("\n        " + _vm._s((_vm$value$contact2 = _vm.value.contact) === null || _vm$value$contact2 === void 0 ? void 0 : _vm$value$contact2.phone) + "\n      ")])]), _vm._v(" "), (_vm$value$contact3 = _vm.value.contact) !== null && _vm$value$contact3 !== void 0 && _vm$value$contact3.email ? _c('div', {
    staticClass: "order-summary__props-wrapper"
  }, [_c('div', {
    staticClass: "order-summary__prop"
  }, [_vm._v("\n        Email:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__value"
  }, [_vm._v("\n        " + _vm._s(_vm.value.contact.email) + "\n      ")])]) : _vm._e()]), _vm._v(" "), (_vm$value$delivery = _vm.value.delivery) !== null && _vm$value$delivery !== void 0 && _vm$value$delivery.type ? _c('div', {
    staticClass: "order-summary__block"
  }, [_c('div', {
    staticClass: "order-summary__title"
  }, [_vm._v("\n      Доставка\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__props-wrapper"
  }, [_c('div', {
    staticClass: "order-summary__prop"
  }, [_vm._v("\n        Город:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__value"
  }, [_vm._v("\n        " + _vm._s((_vm$city = _vm.city) === null || _vm$city === void 0 ? void 0 : _vm$city.name) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__props-wrapper"
  }, [_c('div', {
    staticClass: "order-summary__prop"
  }, [_vm._v("\n        Способ:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__value"
  }, [_vm._v("\n        " + _vm._s(_vm.value.delivery.type.title) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__props-wrapper"
  }, [_c('div', {
    staticClass: "order-summary__prop"
  }, [_vm._v("\n        Адрес:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__value"
  }, [_vm._v("\n        " + _vm._s(_vm.summaryValue) + "\n      ")])]), _vm._v(" "), _vm.value.delivery.recipient ? _c('div', {
    staticClass: "order-summary__props-wrapper"
  }, [_c('div', {
    staticClass: "order-summary__prop"
  }, [_vm._v("\n        Получатель:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__value"
  }, [_vm._v("\n        " + _vm._s(_vm.value.delivery.recipient) + "\n      ")])]) : _vm._e(), _vm._v(" "), _vm.value.delivery.recipientPhone ? _c('div', {
    staticClass: "order-summary__props-wrapper"
  }, [_c('div', {
    staticClass: "order-summary__prop"
  }, [_vm._v("\n        Телефон получателя:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__value"
  }, [_vm._v("\n        " + _vm._s(_vm.value.delivery.recipientPhone) + "\n      ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm$value$payment = _vm.value.payment) !== null && _vm$value$payment !== void 0 && _vm$value$payment.type ? _c('div', {
    staticClass: "order-summary__block"
  }, [_c('div', {
    staticClass: "order-summary__title"
  }, [_vm._v("\n      Оплата\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__props-wrapper"
  }, [_c('div', {
    staticClass: "order-summary__prop"
  }, [_vm._v("\n        Способ:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "order-summary__value"
  }, [_vm._v("\n        " + _vm._s(_vm.value.payment.type.title) + "\n      ")])])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }